import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  stacked: false,
  plugins: {
    plugin1: false,
    plugin2: false,
    datalabels: false,
    legend: {
      display: false,
    },
  },
  scales: {
    x: {
      display: true,
      grid: {
        display: true,
      },
      border: {
        display: false
      },
      ticks: {
        color: '#000',
      }
    },
    y: {
      display: false,
    },
    y1: {
      display: false,
    },
  },
  elements: {
    line: {
      tension: 0.4
    }
  }
};


function EmotionLineChart({emotionData}) {
  const [chartData, setChartData] = useState({});

  useEffect(()=>{
    if(emotionData){
        const sessionNums = emotionData.map(item => item.sessionNum);

        const emotions = {};

        emotionData.forEach(session => {
            session.emotionInfoList.forEach(emotion => {
                // emotionCode를 기반으로 각 감정의 데이터를 수집
                if (!emotions[emotion.emotionCode]) {
                    // 새로운 감정코드가 있으면 초기화
                    emotions[emotion.emotionCode] = {
                        label: emotion.emotionName,
                        backgroundColor: emotion.color,
                        borderColor: emotion.color,
                        data: Array(sessionNums.length).fill(null)  // 데이터 길이만큼 null 값으로 초기화
                    };
                }
                // sessionNum에 맞는 위치에 score 삽입
                const sessionIndex = sessionNums.indexOf(session.sessionNum);
                emotions[emotion.emotionCode].data[sessionIndex] = emotion.score;
            });
        });
        setChartData({
            labels: sessionNums.map(session=>`${session}주차`),
            datasets: Object.values(emotions)
        })
    }
  },[emotionData])

  return Object.keys(chartData).length ? <Line options={options} data={chartData} /> : null;
}

export default EmotionLineChart;